import { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'contexts/AuthContext'

type RouteGuardProps = {
  children: ReactElement,
  /**
   * Required roles, expressed with the BE Spring Security style prefix
   * (e.g. ['ROLE_DEVELOPER','ROLE_ADMIN']). Caller passes any role; access is
   * granted if the user has at least one match.
   */
  requiredRoles: string[]
}

function RouteGuard({ children, requiredRoles }: RouteGuardProps) {
  const { roles, isLoggedIn, loading } = useAuth()

  if (loading) return <div>Loading...</div>
  if (!isLoggedIn) return <Navigate to="/login" replace />

  const has = requiredRoles.some((r) => roles.includes(r))
  if (requiredRoles.length > 0 && !has) {
    return <Navigate to="/unauthorized" replace />
  }
  return children
}

export default RouteGuard
